/* PureChews 2.0: perforations tear open and content rises as each sachet scrolls in. */
(function(){
  var els = document.querySelectorAll('.perf.tear, .rip, .rise');
  if(!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches){
    els.forEach(function(el){ el.classList.add('in'); }); return;
  }
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });
  els.forEach(function(el, i){
    if(el.classList.contains('rise')){
      var sibs = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.querySelectorAll(':scope > .rise'), el) : 0;
      el.style.transitionDelay = Math.max(0, sibs) * 90 + 'ms';
    }
    io.observe(el);
  });
})();
